const DOMAIN_ALIASES: Record<string, string> = {
  "youtu.be": "youtube",
  "discord.gg": "discord",
  "mym.fans": "mym",
  "ourdreamersai13.com": "ourdreamers",
  "x.com": "twitter",
};

export const getSocialNameFromHostname = (hostname: string): string | null => {
  const normalizedHostname = hostname.toLowerCase().replace(/^www\./, "");

  const matchedAlias = Object.keys(DOMAIN_ALIASES).find(
    (domain) =>
      normalizedHostname === domain ||
      normalizedHostname.endsWith(`.${domain}`),
  );

  if (matchedAlias) {
    return DOMAIN_ALIASES[matchedAlias];
  }

  const parts = normalizedHostname.split(".");

  if (parts.length < 2) {
    return null;
  }

  return parts[parts.length - 2] ?? null;
};

export const getSocialNameFromUrl = (url: string): string | null => {
  try {
    return getSocialNameFromHostname(new URL(url).hostname);
  } catch {
    return null;
  }
};
